var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8EA38D",
    d: "M53.0162 27.2878l.0006.0264.0004.0327-.0002.254c-.0305 2.709-1.0237 22.1448-23.16 24.5817 0 0-1.2865-22.602 23.1592-24.8948zm-47.6165 0c24.4456 2.2929 23.1591 24.8948 23.1591 24.8948C5.2321 49.6146 5.3837 28.171 5.3991 27.3142zm39.0332-8.8442c1.6191 1.4843 1.8324 5.7698 1.8398 7.7798l-.0005.3052c-.003.4727-.0164.7592-.0164.7592-11.8112 4.1666-15.452 12.4086-16.5649 16.6975l-.087.348c-.3527 1.4673-.3962 2.3899-.3962 2.3899l-.0009-.0162c-.0311-.5266-.9704-13.748-17.0468-19.4192 0 0-.3214-6.8785 1.823-8.8442 0 0 13.092 4.5861 15.2247 16.815 2.133-12.2289 15.2252-16.815 15.2252-16.815zm-15.2252-6.0054c4.7182 3.0576 6.6475 10.0454 6.6475 10.0454s-5.3606 3.1666-6.6475 8.8442c-1.0638-4.695-4.9138-7.6728-6.2146-8.563l-.1645-.1106c-.1713-.1132-.2684-.1706-.2684-.1706s1.9298-6.9878 6.6475-10.0454z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28,
    stroke: "#637470",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbol);
export default __webpack_public_path__ + "static/media/logo-symbol.714c4abd.svg";
export { ForwardRef as ReactComponent };